import { topics } from "@/mocks/features";
import { SectionHead } from "./bits";

export default function Topics() {
  return (
    <section id="topics" className="scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <SectionHead
          eyebrow="Topics"
          title="深挖专题 · 不止于吃瓜"
          desc="针对税务问题与合同纠纷两大长线议题的年度观察专题，把行业机制、条款逻辑与典型案例放在一起，给出可独立判断的方法论。"
        />

        <div className="grid gap-6 lg:grid-cols-2">
          {topics.map((t) => (
            <article
              key={t.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50"
            >
              <div className="relative h-48 w-full overflow-hidden md:h-56">
                <img
                  src={t.image}
                  alt={t.imageAlt}
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950">
                  {t.kind}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6 md:p-7">
                <h3 className="font-heading text-xl font-bold leading-snug text-foreground-950 md:text-[22px]">
                  {t.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{t.desc}</p>
                <ul className="mt-5 space-y-2.5">
                  {t.points.map((p, i) => (
                    <li key={i} className="flex items-start gap-2.5 text-sm text-foreground-700">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                        <i className="ri-check-line text-xs" />
                      </span>
                      <span className="leading-relaxed">{p}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-5 flex items-center justify-between border-t border-background-100 pt-4 text-xs text-foreground-400">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-file-list-3-line text-primary-500" /> 专题持续更新中
                  </span>
                  <span>最近更新 09-09</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}